package com.neurobs.react

import org.scalajs.dom.html.Input
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.web.html._

class EditWrapperReact(initialValue: String) extends SingleValueControlWrapperReactBase[String, Input](initialValue) {
	override protected def controlValue(control: Input): String = control.value
	override protected def setControlValue(control: Input, newValue: String): Unit = { control.value = newValue }
}

/** Single-line unmanaged edit control whose value is accessed using a EditControlWrapperReact
 *
 */
@react object Edit {
	case class Props
	(
		state: EditControlWrapper,
		emWidth: Double,
		disabled: Boolean = false,
		readOnly: Boolean = false,
		password: Boolean = false,
		autocomplete: String = "",
		onChange: Option[() => Unit] = None
	)
	val component = FunctionalComponent[Props] { props =>
		val wrapper = props.state.asInstanceOf[EditWrapperReact]
		useEffect( { () =>
			() => {
				if (wrapper.ref.current != null) {
					wrapper.valueCache = wrapper.ref.current.value
				}
			}
		}, List(wrapper.ref))

		input(
			ref := wrapper.ref,
			`type` := (if (props.password) "password" else "text"),
			defaultValue := wrapper.valueCache,
			disabled := props.disabled,
			readOnly := props.readOnly,
			style := StyleUtil.makeStyle(("width", s"${props.emWidth}em")),
			className := (if (props.password) defaultPasswordInputClass else defaultTextInputClass),
			onChange := props.onChange,
			autoComplete := props.autocomplete
		)
	}

	private val defaultTextInputClass = "efactory-text-input"
	private val defaultPasswordInputClass = "efactory-password-input"
}

/** Password edit control that has a visible toggle control to the right of the edit box */
@react object VisiblePasswordEdit {
	case class Props
	(
		state: EditControlWrapper,
		emWidth: Double,
		disabled: Boolean = false,
		readOnly: Boolean = false,
		password: Boolean = false,
		autocomplete: String = "",
		onChange: Option[() => Unit] = None
	)
	val component = FunctionalComponent[Props] { props =>
		val (visible, setVisible) = useState(default = false)
		span(
			Edit(state = props.state, emWidth = props.emWidth, disabled = props.disabled, readOnly = props.readOnly, password = !visible, autocomplete = props.autocomplete, onChange = props.onChange),
			" ",
			a(
				className := defaultLinkClass,
				onClick := {() => setVisible(!visible)},
				if (visible) "\uD83D\uDD76" else "\uD83D\uDC53"
			)
		)
	}

	private val defaultLinkClass = "efactory-link"
}